import type { AdminAssetProcessingActivityReviewDetail } from 'config/api/ropaReviews/ropaReviews.types';

type DecisionDisabledTooltipMessages = {
  acceptBlockedChangedAfterSubmission: string;
  acceptAwaitingResponse: string;
  acceptClarificationRequested: string;
  acceptAlreadyAccepted: string;
  acceptUnavailable: string;
  clarificationAwaitingResponse: string;
  clarificationAlreadyRequested: string;
  clarificationAlreadyAccepted: string;
  clarificationUnavailable: string;
};

export const getAcceptDisabledTooltip = (
  detail: AdminAssetProcessingActivityReviewDetail,
  messages: DecisionDisabledTooltipMessages,
): string => {
  if (detail.changedAfterSubmission) {
    return messages.acceptBlockedChangedAfterSubmission;
  }

  if (detail.actions.canAccept) {
    return '';
  }

  switch (detail.reviewRow.status) {
    case 'awaiting_response':
      return messages.acceptAwaitingResponse;
    case 'clarification_requested':
      return messages.acceptClarificationRequested;
    case 'accepted':
      return messages.acceptAlreadyAccepted;
    default:
      return messages.acceptUnavailable;
  }
};

export const getClarificationDisabledTooltip = (
  detail: AdminAssetProcessingActivityReviewDetail,
  messages: DecisionDisabledTooltipMessages,
): string => {
  if (detail.actions.canRequestClarification) {
    return '';
  }

  switch (detail.reviewRow.status) {
    case 'awaiting_response':
      return messages.clarificationAwaitingResponse;
    case 'clarification_requested':
      return messages.clarificationAlreadyRequested;
    case 'accepted':
      return messages.clarificationAlreadyAccepted;
    default:
      return messages.clarificationUnavailable;
  }
};
